import React from 'react'
import PropTypes from 'prop-types'
import { Chip } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styles from './StatusChip.module.scss'

const colorMap = {
  success: 'var(--color-success)',
  error: 'var(--color-error)',
  warning: 'var(--color-warning)',
  info: 'var(--color-info)',
  primary: 'var(--color-brand-primary)',
  neutral: 'var(--color-text-secondary)'
}

const filledColorMap = {
  success: 'var(--color-success-filled, var(--color-success))',
  error: 'var(--color-error-filled, var(--color-error))',
  warning: 'var(--color-warning-filled, var(--color-warning))',
  info: 'var(--color-info-filled, var(--color-info))',
  primary: 'var(--color-brand-primary-filled, var(--color-brand-primary))',
  neutral: 'var(--color-neutral-filled, #64748b)'
}

const StatusChip = ({
  label,
  color = 'neutral',
  icon,
  size = 'medium',
  variant = 'filled'
}) => {
  const baseColor = colorMap[color] || colorMap.neutral
  const filledBg = filledColorMap[color] || filledColorMap.neutral

  const chipIcon = icon
    ? <FontAwesomeIcon icon={icon} className={styles.icon} aria-hidden='true' />
    : undefined

  const chipStyle = variant === 'filled'
    ? { backgroundColor: filledBg, color: '#fff' }
    : variant === 'outlined'
      ? { border: `1px solid ${baseColor}`, color: baseColor, backgroundColor: 'transparent' }
      : { backgroundColor: baseColor, color: baseColor }

  return (
    <Chip
      label={label}
      icon={chipIcon}
      size={size === 'small' ? 'small' : 'medium'}
      className={`${styles.chip} ${styles[variant]} ${styles[size]}`}
      style={chipStyle}
    />
  )
}

StatusChip.propTypes = {
  label: PropTypes.string.isRequired,
  color: PropTypes.oneOf(['success', 'error', 'warning', 'info', 'primary', 'neutral']),
  icon: PropTypes.object,
  size: PropTypes.oneOf(['small', 'medium']),
  variant: PropTypes.oneOf(['filled', 'outlined', 'soft'])
}

export default StatusChip
